const values = [
  "dryad_panel",
  "lionking_panel",
  "npe_panel",
];
export default values;
